// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__b3eL_","back":"styles_back__1saZ2"};